import React from 'react';

export const Pulse = ({ className = '' }) => {
  return <span className={`block animate-pulse rounded-[0.8rem] bg-[rgba(255,255,255,0.08)] ${className}`} />;
};
